import { AlertColor } from '@mui/material'
import { SNACKBAR_DISPLAY, SNACKBAR_HIDE } from '../../utils/constants'

interface MainStore {
    snackbar: {
        open: boolean
        message: string
        severity: AlertColor
    }
}

const initialState: MainStore = {
    snackbar: {
        open: false,
        message: '',
        severity: 'info',
    },
}

export default (state = initialState, action: any): MainStore => {
    switch (action.type) {
        case SNACKBAR_DISPLAY:
            return {
                ...state,
                snackbar: {
                    open: true,
                    severity: action.payload.severity,
                    message: action.payload.message,
                },
            }
        case SNACKBAR_HIDE: {
            return {
                ...initialState,
            }
        }
        default:
            return state
    }
}
